import './HeroLayoutThree.css';
import { useEffect, useState } from 'react';
import { CacheProvider } from '@emotion/react';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
// import { FrontAwesomeIcon } from '@fortawesome/react-frontawesome';
// import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { appendStyleSheet, getEndpoint, getID, getMUICache, getUrl, getImageSize, getImageUrl, convertEpochTime, getImageId, fetchAnchorValue, GetFallBackImage, isImageSizeBlank, GetIconsSprites } from '../../../common/utils';
import { I_CDSListingItemTO } from '@interfaces/ICDSListingResponseTO';
import bcrypt from 'bcryptjs-react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';

HeroLayoutThree.version = 1000;

HeroLayoutThree.lang = 'en';
HeroLayoutThree.langs = [
  'en'
];
HeroLayoutThree.setLang = (lang: any) => {
  HeroLayoutThree.lang = lang;
}

Object.defineProperty(HeroLayoutThree, 'name', {
  writable: true,
  value: 'HeroLayoutThree'
});

export function HeroLayoutThree(props: any) {
  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();

  useEffect(()=>{
    EagerLoadImages()
},[]);

  const { anchorLinksValue } = props;

  let styles = require("./HeroLayoutThree.css");
  const [msid, setMsid] = useState<any>('');
  const [items, setItems] = useState<I_CDSListingItemTO[]>([]);
  appendStyleSheet("HeroLayoutThree", styles);
  const endpoint = getEndpoint(props);
  const { mainHeading, mainHeadingHref, textColor, showDate, showAuthor } = props
  //const preloadSet = useRef(new Set<string>()); // Track preloaded image URLs


  // Preload images when items are available
  // useEffect(() => {
  //   if (items.length > 0) {
  //     items.forEach(item => {
  //       const imageUrl = getImageUrl(getImageId(item.imageid), getImageSize(item.imageid), 1440, 768, "", false, props.CONSTANTS);
  //       if (!preloadSet.current.has(imageUrl)) {
  //         const link = document.createElement('link');
  //         link.rel = 'preload';
  //         link.href = imageUrl;
  //         link.as = 'image';
  //         document.head.appendChild(link);
  //         preloadSet.current.add(imageUrl); 
  //       }
  //     });
  //   }
  // }, [items, props.CONSTANTS]);

  // Preload images when items are available
  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }

  }, [props.MSID, endpoint, props.showAdSlot]);

  const setItemsObj = (response: any) => {
    setItems(response.items)
  }

  if (endpoint.isSSR && endpoint.SSRDataObj && (!items || !items.length)
    && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
    setItemsObj(endpoint.SSRDataObj);
  }

  const fetchComponentData = () => {
    getData(getUrl(props));
  }

  const getData = (url: string) => {
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(url, { headers: headers })
      .then((response) => response.json())
      .then(response => {
        setItemsObj(response);
      })
      .catch(err => {
        //console.log(err);
      });
  }
  const getRenderPart = () => {
    if (msid && props.msid && msid != props.msid) {
      props.queryParams.msid = props.msid;
      setMsid(props.queryParams.msid);
      getData(getUrl(props));
    }

    if (!items || !items.length) {
      return "";
    }

    let componentID = getID(props.data);


    return <CacheProvider value={getMUICache()}>
      <div id={componentID}>
        <div className='commoncontainer'>
          <div className='ThemeThreeHeadingMainWrapper'>
            <p className='ThemeThreeCommonSubHeading'>NEWS UPDATE</p>
            <p className='themeThreeCommonComponentsHeading'><Link style={{ color: textColor }} href={mainHeadingHref} target={fetchAnchorValue(anchorLinksValue, mainHeadingHref)} >{mainHeading}</Link></p>
          </div>
          <Grid className='masterHeroLayout'>
            <div className='themeThreeRightsideHeroLayout'>
              {items &&
                items.map((itemObj, index) => {
                  if (index == 0) {
                    return <><Link href={itemObj.wu} key={'2_' + index} style={{ color: props.mainHeadingColor }} target={fetchAnchorValue(anchorLinksValue, itemObj.wu)} className='ThemeThreeWebHeroLayoutCardWrapSlide'>
                      <div className='ThemeThreeWebHeroLayoutCardWrap'>
                        <div className='ThemeThreeWebHeroLayoutCardImgWrap'>

                        {isImageSizeBlank(itemObj.imageid) ? <picture>
                              <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 520, 390, "", false, props.CONSTANTS)} />
                              <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 390, 293, "", false, props.CONSTANTS)} />
                              <img alt={itemObj?.hl?.slice(0, 25) ?? ''} title={itemObj?.hl?.slice(0, 25) ?? ''} loading="lazy" />
                            </picture>: <img src={GetFallBackImage()} alt={itemObj?.hl?.slice(0, 25) ?? ''} title={itemObj?.hl?.slice(0, 25) ?? ''} loading="lazy"/>}
                        </div>
                        <div className='themeThreedateAgencyWrap'>
                          {showDate && <p className='ThemeThreeCommonAuthorWrapper '>{convertEpochTime(itemObj.lpt, 'updated', "DD MMM YYYY")}</p>}
                          {showAuthor && <p className='themeThreeHeroLayoutDateTimeAgency '>By <span className='manageAuthorName'>{itemObj.au}</span></p>}
                        </div>
                        <div className='ThemeThreeWebHeroLayoutCarContentWrap'>
                          <p className='HeroLayoutDiscription'>{itemObj.hl}</p>
                        </div>
                        <div className='themeThreeHeroLayoutsSumWrap'>
                          <p className='themeThreeHeroLayoutsSummry'>{itemObj.syn}</p>
                        </div>
                      </div>
                    </Link>
                    </>
                  }
                  else if (index > 0 && index < 7) {
                    return <>
                      <Link href={itemObj.wu} key={'2_' + index} style={{ color: props.mainHeadingColor }} target={fetchAnchorValue(anchorLinksValue, itemObj.wu)} className='ThemeThreeWebHeroLayoutCardWrapSlide'>
                        <div className='AngleIconWrap'>
                          {/* <FrontAwesomeIcon icon={faAngleRight} /> */}
                          <div className='bg-Keyboard_arrow_right_T3 ' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                        </div>
                        <div className='ThemeThreeWebHeroLayoutCardWrap'>
                          <div className='ThemeThreeWebHeroLayoutCarContentWrap'>
                            <p className='HeroLayoutDiscription'>{itemObj.hl}</p>
                          </div>
                        </div>
                      </Link>
                    </>
                  }
                })}
            </div>
            <div className='themeThreeLeftsideHeroLayout'>
              {items &&
                items.map((itemObj, index) => {
                  if (index > 0 && index < 7) {
                    return <>
                      <Link href={itemObj?.wu} key={'2_' + index} style={{ color: props.mainHeadingColor }} target={fetchAnchorValue(anchorLinksValue, itemObj?.wu)} className='ThemeThreeWebHeroLayoutCardWrapSlide'>
                        <div className='ThemeThreeWebHeroLayoutCardWrap' style={{ backgroundColor: props.cardActiveColor }}>
                          <div className='ThemeThreeWebHeroImgWrap'>
                           {isImageSizeBlank(itemObj.imageid) ? <picture>
                              <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 280, 210, "", false, props.CONSTANTS)} />
                              <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 180, 135, "", false, props.CONSTANTS)} />
                              <img alt={itemObj?.hl?.slice(0, 25) ?? ''} title={itemObj?.hl?.slice(0, 25) ?? ''} loading="lazy" />
                            </picture>: <img src={GetFallBackImage()} alt={itemObj?.hl?.slice(0, 25) ?? ''} title={itemObj?.hl?.slice(0, 25) ?? ''} loading="lazy"/>}
                          </div>
                          <div className='ThemeThreeWebHeroLayoutCarContentWrap'>
                            <p className='HeroLayoutDiscription'><span className='InsideCommonTags'>{itemObj?.cat}</span>{itemObj?.hl}</p>
                          </div>
                          <div className='themeThreedateAgencyWrap'>
                            {showDate && <p className='ThemeThreeCommonAuthorWrapper'>{convertEpochTime(itemObj?.lpt, 'updated', "DD MMM YYYY")}</p>}
                            {showAuthor && <p className='themeThreeHeroLayoutDateTimeAgency'>By <span className='manageAuthorName'>{itemObj?.au}</span></p>}
                          </div>
                        </div>
                      </Link>

                    </>
                  }
                  else {
                    return null
                  }
                }
                )}
            </div>

          </Grid>
        </div>
      </div>
    </CacheProvider>
  }
  return (
    <>
      {getRenderPart()}
    </>
  );

}

